import { Component, computed, input } from '@angular/core'
import { ColDef, GetRowIdFunc } from 'ag-grid-community'
import { AgGridAngular } from 'ag-grid-angular'
import { TableLoadingOverlayComponent } from './overlays/table-loading-overlay.component'
import { TableNoDataOverlayComponent } from './overlays/table-no-data-overlay.component'

@Component({
  selector: 'app-data-table',
  imports: [AgGridAngular],
  styles: `
      :host {
          display: flex;
          flex-direction: column;
          justify-content: start;
      }
    `,
  template: `
    <ag-grid-angular
      class="app-table"
      [style]="styleAttribute()"
      [getRowId]="getRowId()"
      [defaultColDef]="defaultColDef()"
      [columnDefs]="columnDefs()"
      [rowData]="data()"
      [suppressPaginationPanel]="true"
      [suppressDragLeaveHidesColumns]="true"
      [suppressNoRowsOverlay]="loading()"
      [loadingOverlayComponent]="LoadingOverlayComponent"
      [noRowsOverlayComponent]="NoDataOverlayComponent"
      [noRowsOverlayComponentParams]="noRowsOverlayParams"
      [pagination]="false"
      [enableCellTextSelection]="true"
      [loading]="loading()"
    />
  `,
})
export class DataTableComponent<T> {
  readonly data = input.required<T[]>()
  readonly getRowId = input.required<GetRowIdFunc<T>>()
  readonly columnDefs = input.required<ColDef[]>()
  readonly defaultColDef = input<ColDef>()
  readonly heightStyle = input('65vh')
  readonly loading = input(false)
  readonly suppressNoRowsOverlay = input(false)

  protected readonly styleAttribute = computed(() => `height: ${this.heightStyle()}`)

  protected LoadingOverlayComponent = TableLoadingOverlayComponent
  protected NoDataOverlayComponent = TableNoDataOverlayComponent
  protected noRowsOverlayParams = { error: false }

}
